import React, { useState } from "react";
import {
  Flex,
  Box,
  Text,
  Button,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from "@chakra-ui/react";

import TopSlider from "../Home/TopSlider";

import digi from "../../assets/icons/digi.png";
import ai from "../../assets/icons/AI-gift.png";
import reminder from "../../assets/icons/bell.png";
import wish from "../../assets/icons/02_wishlist.png";
import eve from "../../assets/icons/event.png";
import promo from "../../assets/icons/promos.png";
import main from "../../assets/icons/main.png";

const BoxModal = ({ isOpen, onClose, selectedContent }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Box Details</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>{selectedContent}</Text>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
const AboutsUs = () => {
  const [selectedBoxContent, setSelectedBoxContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <TopSlider />
      <Box mt={5} mb={14}>
        <Flex alignItems={"center"} px={5} gap={10}>
          <Box w={"50%"}>
            <Image src={main} />
          </Box>
          <Box w={"50%"} textAlign={"left"}>
            <Text
              className="oswald-font"
              fontWeight={"bold"}
              fontSize={30}
              mb={4}
            >
              About Us
            </Text>
            <Text
              className="lato-font"
              color={"gray.500"}
              fontWeight={"regular"}
            >
              At Wishfy, our commitment extends beyond traditional celebration
              planning. We believe in transforming ordinary moments into
              extraordinary memories, offering a comprehensive suite of services
              that go above and beyond the typical event planning experience.
              <div className="mb-2"></div>
              Central to our ethos is the conviction that every occasion,
              irrespective of its scale, deserves to be cherished and celebrated
              to the fullest. Wishfy is not just an app; it's a vibrant and
              joyful platform meticulously designed to assist you in creating
              unforgettable memories. Whether you're organizing a birthday bash,
              a graduation ceremony, a wedding extravaganza, or commemorating a
              personal achievement, Wishfy is here to be your ultimate
              companion.
              <div className="mb-2"></div>
              Our mission is to provide you with a seamless and intuitive
              experience. From the inception of an idea to the execution of a
              flawless celebration, we offer a wide range of features and tools
              that cover every step of the celebration planning process.
              Personalized invitations set the tone, while our robust event
              management tools ensure that no detail is overlooked. We strive to
              make the journey of planning and executing your celebration as
              enjoyable as the event itself.
              <div className="mb-2"></div>
              What sets Wishfy apart is our commitment to sustainability and
              holistic living. In addition to our core celebration planning
              services, we proudly introduce unique offerings such as curated
              plant gifts. Imagine gifting not just a present but a living,
              breathing symbol of growth and prosperity. Our plant gifts are
              thoughtfully selected to add a touch of nature to your
              celebrations, fostering sustainability and green living.
              <div className="mb-2"></div>
              Furthermore, Wishfy brings the outdoors closer to home with our
              on-demand gardener services. Transform your living spaces into
              personalized green havens with the help of experienced and skilled
              gardeners available at your fingertips. Whether you desire a cozy
              balcony garden or a backyard oasis, our on-demand gardener
              services make it possible for you to nurture nature effortlessly.
              <div className="mb-2"></div>
              For those seeking to redefine their surroundings, Wishfy takes it
              a step further by offering professional landscape design and
              maintenance services. Our expert designers collaborate with you to
              create outdoor spaces that reflect your style and personality.
              From conceptualization to regular maintenance, we ensure that your
              outdoor spaces remain aesthetically pleasing and harmonious with
              nature.
              <div className="mb-2"></div>
              In essence, Wishfy is not just a celebration planning app; it's a
              lifestyle companion. We are dedicated to making every moment
              count, be it through unforgettable celebrations or sustainable
              living practices. Let Wishfy be the guiding force in your journey
              to creating vibrant, joyous memories and spaces that stand the
              test of time.
            </Text>
          </Box>
        </Flex>
        <Box textAlign={"left"} p={5} pl={10} pr={10} mt={5}>
          <Text
            color={"#97AEFC"}
            fontWeight={"semibold"}
            className="oswald-font"
            fontSize={18}
          >
            Services
          </Text>
          <Text fontWeight={"regular"} className="lato-font">
            What We Offer
          </Text>
          <Box
            mt={10}
            display={"grid"}
            gridTemplateColumns={{ md: "repeat(3,1fr)", base: "repeat(1,1fr)" }}
            gap={10}
          >
            <Box
              boxShadow={
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;"
              }
              h={320}
              borderRadius={20}
              pl={5}
              pr={5}
            >
              <Image src={digi} m={"auto"} w={24} mb={10} h={20} />
              <Text
                fontWeight={"bold"}
                fontSize={20}
                className="oswald-font"
                mt={4}
              >
                Digital Invitation
              </Text>
              <Text fontWeight={"regular"} fontSize={14} mt={2}>
                Unleash your inner artist and explore our exceptional range of
                cards for every occasion, available at your fingertips. With
                just a few clicks, you can polish your selection and create a
                truly memorable experience...
              </Text>
              <Flex justifyContent={"end"} mt={4}>
                <Button
                  borderRadius={50}
                  color={"white"}
                  bg={"#FC1A64"}
                  p={5}
                  fontSize={18}
                  onClick={() => {
                    setSelectedBoxContent(
                      "Unleash your inner artist and explore our exceptional range of cards for every occasion, available at your fingertips. With just a few clicks, you can polish your selection and create a truly memorable experience. At Wishfy, we understand the power of a well-crafted card. It’s not just a piece of paper; it’s an expression of love, joy, gratitude, and celebration. That’s why we’ve curated a diverse collection of cards, meticulously designed to cater to all your special moments. Whether you’re sending birthday wishes, expressing heartfelt congratulations, offering condolences, or simply spreading some cheer, our extensive range of cards has got you covered. Choose from a variety of stunning themes, captivating designs, and artistic styles, all crafted by talented artists"
                    );
                    setIsModalOpen(true);
                  }}
                >
                  Know More
                </Button>
              </Flex>
            </Box>
            {/*  */}
            <Box
              boxShadow={
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;"
              }
              h={320}
              borderRadius={20}
              pl={5}
              pr={5}
            >
              <Image src={wish} m={"auto"} w={24} mb={10} h={20} />
              <Text
                fontWeight={"bold"}
                fontSize={20}
                className="oswald-font"
                mt={4}
              >
                Wishlist
              </Text>
              <Text fontWeight={"regular"} fontSize={14} mt={2}>
                Discovering the perfect gift can be overwhelming. Avoid the
                stress of duplicate or unwanted presents with our AI-powered
                platform. We provide tailored gifting ideas for every
                occasion....
              </Text>
              <Flex justifyContent={"end"} mt={4}>
                <Button
                  borderRadius={50}
                  color={"white"}
                  bg={"#FC1A64"}
                  p={5}
                  fontSize={18}
                  onClick={() => {
                    setSelectedBoxContent(
                      "Discovering the perfect gift can be overwhelming. Avoid the stress of duplicate or unwanted presents with our AI-powered platform. We provide tailored gifting ideas for every occasion. Simply provide a few inputs, and we’ll offer you the best suggestions, complete with purchase links. Create and share your personalized wishlist hassle-free. Find the ideal gift effortlessly with our intuitive platform."
                    ); // Replace 'boxContent' with the actual content of the box
                    setIsModalOpen(true);
                  }}
                >
                  Know More
                </Button>
              </Flex>
            </Box>
            {/*  */}
            <Box
              boxShadow={
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;"
              }
              h={320}
              borderRadius={20}
              pl={5}
              pr={5}
            >
              <Image src={reminder} m={"auto"} w={24} mb={10} h={20} />
              <Text
                fontWeight={"bold"}
                fontSize={20}
                className="oswald-font"
                mt={4}
              >
                Event Reminder & Schedule
              </Text>
              <Text fontWeight={"regular"} fontSize={14} mt={2}>
                Event Reminder & Schedule feature. Stay organized and ensure you
                never miss a birthday or important event again with our
                intuitive Event Reminder & Schedule feature....
              </Text>
              <Flex justifyContent={"end"} mt={4}>
                <Button
                  borderRadius={50}
                  color={"white"}
                  bg={"#FC1A64"}
                  p={5}
                  fontSize={18}
                  onClick={() => {
                    setSelectedBoxContent(
                      "Event Reminder & Schedule feature. Stay organized and ensure you never miss a birthday or important event again with our intuitive Event Reminder & Schedule feature. We understand how hectic life can get, so let our app be your reliable companion in keeping track of all your special occasions. Our Event Reminder & Schedule feature allows you to effortlessly manage your calendar by setting reminders for birthdays, anniversaries, holidays, meetings, and any other significant events. Simply input the event details, including date, time, and description, and let our app handle the rest. Receive timely notifications and alerts that ensure you’re always prepared and never caught off guard. No more scrambling to find last-minute gifts or sending belated wishes. Our feature helps you plan ahead, so you can celebrate and connect with your loved ones on time, making every occasion memorable. With our user-friendly interface, scheduling events is a breeze. Easily navigate through your calendar, add or edit events, and even set recurring reminders for those annual occasions. Our app keeps everything organized in one place, ensuring you stay on top of your busy schedule. Say goodbye to the stress of remembering important dates. Let our Event Reminder & Schedule feature be your personal assistant, allowing you to focus on what truly matters – enjoying meaningful moments with family, friends, and colleagues. Download our app today and never miss a birthday or important event again. Stay organized, be punctual, and make every occasion count with our reliable Event Reminder & Schedule feature."
                    ); // Replace 'boxContent' with the actual content of the box
                    setIsModalOpen(true);
                  }}
                >
                  Know More
                </Button>
              </Flex>
            </Box>
            {/*  */}
            <Box
              boxShadow={
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;"
              }
              h={320}
              borderRadius={20}
              pl={5}
              pr={5}
            >
              <Image src={eve} m={"auto"} w={24} mb={10} h={20} />
              <Text
                fontWeight={"bold"}
                fontSize={20}
                className="oswald-font"
                mt={4}
              >
                Plan An Event
              </Text>
              <Text fontWeight={"regular"} fontSize={14} mt={2}>
                Planning an important celebration within your budget can be a
                nightmare. But worry no more, Wishfy is here to help! Discover
                the perfect venue for your special occasion without breaking...
              </Text>
              <Flex justifyContent={"end"} mt={4}>
                <Button
                  borderRadius={50}
                  color={"white"}
                  bg={"#FC1A64"}
                  p={5}
                  fontSize={18}
                  onClick={() => {
                    setSelectedBoxContent(
                      "Planning an important celebration within your budget can be a nightmare. But worry no more, Wishfy is here to help! Discover the perfect venue for your special occasion without breaking the bank. With Wishfy, you can easily find, explore, review, and book your desired venue, all in one convenient place. Our team of experts is dedicated to assisting you throughout your planning journey. Trust Wishfy to make your celebration memorable and stress-free."
                    ); // Replace 'boxContent' with the actual content of the box
                    setIsModalOpen(true);
                  }}
                >
                  Know More
                </Button>
              </Flex>
            </Box>
            {/*  */}
            <Box
              boxShadow={
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;"
              }
              h={320}
              borderRadius={20}
              pl={5}
              pr={5}
            >
              <Image src={promo} m={"auto"} w={24} mb={10} h={20} />
              <Text
                fontWeight={"bold"}
                fontSize={20}
                className="oswald-font"
                mt={4}
              >
                Digital Promos
              </Text>
              <Text fontWeight={"regular"} fontSize={14} mt={2}>
                We provide a platform that not only allows you to send
                personalized greetings but also enables you to design and create
                shareable digital promos to extend your business reach. With our
                user-friendly tools...
              </Text>
              <Flex justifyContent={"end"} mt={4}>
                <Button
                  borderRadius={50}
                  color={"white"}
                  bg={"#FC1A64"}
                  p={5}
                  fontSize={18}
                  onClick={() => {
                    setSelectedBoxContent(
                      "We provide a platform that not only allows you to send personalized greetings but also enables you to design and create shareable digital promos to extend your business reach. With our user-friendly tools, you can easily design captivating promotional materials tailored to your brand. Boost your business and connect with a wider audience by utilizing our unique features. Embrace the power of greetings and promotions combined on our platform and take your business to new heights."
                    ); // Replace 'boxContent' with the actual content of the box
                    setIsModalOpen(true);
                  }}
                >
                  Know More
                </Button>
              </Flex>
            </Box>
            {/*  */}
            <Box
              boxShadow={
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;"
              }
              h={320}
              borderRadius={20}
              pl={5}
              pr={5}
            >
              <Image src={ai} m={"auto"} w={24} mb={10} h={20} />
              <Text
                fontWeight={"bold"}
                fontSize={20}
                className="oswald-font"
                mt={4}
              >
                AI-Powered Gift Planner
              </Text>
              <Text fontWeight={"regular"} fontSize={14} mt={2}>
                Finding the perfect gift for your loved ones can be a daunting
                task, but worry no more! Our AI-Powered Gift Planner is here to
                make the process seamless and enjoyable. With advanced....
              </Text>
              <Flex justifyContent={"end"} mt={4}>
                <Button
                  borderRadius={50}
                  color={"white"}
                  bg={"#FC1A64"}
                  p={5}
                  fontSize={18}
                  onClick={() => {
                    setSelectedBoxContent(
                      "Finding the perfect gift for your loved ones can be a daunting task, but worry no more! Our AI-Powered Gift Planner is here to make the process seamless and enjoyable. With advanced algorithms and personalized recommendations, we’ll help you discover the ideal gift for any occasion or recipient."
                    ); // Replace 'boxContent' with the actual content of the box
                    setIsModalOpen(true);
                  }}
                >
                  Know More
                </Button>
              </Flex>
            </Box>
            {/*  */}
          </Box>
        </Box>
        <BoxModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          selectedContent={selectedBoxContent}
        />
      </Box>
    </>
  );
};

export default AboutsUs;
